module.exports = __webpack_public_path__ + "img/23.4af9cd23.jpg";